import { render, staticRenderFns } from "./ZoteroHint.vue?vue&type=template&id=f3a018ec&scoped=true"
import script from "./ZoteroHint.vue?vue&type=script&lang=js"
export * from "./ZoteroHint.vue?vue&type=script&lang=js"
import style0 from "./ZoteroHint.vue?vue&type=style&index=0&id=f3a018ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a018ec",
  null
  
)

export default component.exports